import { FC } from 'react';

import {
  InfoListItemStyled,
  InfoListStyled,
  ProviderImage,
} from '../CarRentalCard.styled';
import {
  CarRentalCarConditionProps,
  CarRentalCarFeatureProps,
  CarRentalCarReservationProps,
} from '../CarRentalCardProps';

type InfoListPropTypes = {
  features: CarRentalCarFeatureProps;
  conditions: CarRentalCarConditionProps;
  reservation: CarRentalCarReservationProps;
  providerName: string;
  providerImageUrl: string;
};

const InfoList: FC<InfoListPropTypes> = ({
  features,
  conditions,
  reservation,
  providerName,
  providerImageUrl,
}) => {
  return (
    <InfoListStyled>
      {features?.fuelType ? (
        <InfoListItemStyled>{features?.fuelType}</InfoListItemStyled>
      ) : null}

      {features?.transmissionType ? (
        <InfoListItemStyled>{features?.transmissionType}</InfoListItemStyled>
      ) : null}

      {conditions?.depositAmount ? (
        <InfoListItemStyled>
          {conditions?.depositAmount} TL Depozito
        </InfoListItemStyled>
      ) : null}

      {reservation?.maxKilometer ? (
        <InfoListItemStyled>{reservation?.maxKilometer} Km</InfoListItemStyled>
      ) : null}

      {conditions?.minAge ? (
        <InfoListItemStyled>
          {conditions?.minAge} Yaş Ve Üstü
        </InfoListItemStyled>
      ) : null}

      {providerName && providerImageUrl ? (
        <InfoListItemStyled className='infoListItem__providerImage'>
          <ProviderImage
            src={providerImageUrl}
            alt={providerName}
            title={providerName}
            width={85}
            height={25}
          />
        </InfoListItemStyled>
      ) : null}
    </InfoListStyled>
  );
};

export default InfoList;
